/** Validaciones personalizadas */
import { extend } from 'vee-validate';
import {
	required,
	email,
	excluded,
	required_if,
	min,
	confirmed,
	max,
	alpha,
	alpha_spaces
} from 'vee-validate/dist/rules';
import axiosMailUpdate from '../services/axiosApi';
import urlNotAllowed from '../constants/urlNotAllowed';
import httpCodes from '../constants/httpCodes';
extend('email', email);
extend('required', required);
extend('excluded', excluded);
extend('required_if', required_if);
extend('min', min);
extend('max', max);
extend('alpha', alpha);
extend('alpha_spaces', alpha_spaces);
extend('confirmed', confirmed);
//expresiones regulares para validar el formato de los telefonos
const phoneWithOutParenthesis = /^([0-9]{3})\.([0-9]{4}$)/;
const mobilePhoneRegex = /^((\(04+(12|14|16|24|26)\))([0-9]{3})\.([0-9]{4}$))/;
const phoneWithParenthesis = /^(\(02+([0-9]{2})\))([0-9]{3})\.([0-9]{4}$)/;
const formatExtension = /(^Ext\.+[0-9/]{1,}[0-9])$/
const numbersAfterSlash = /^([0-9]{4}$)/;
//daocumento fiscal
extend('validFiscalID', {
	validate: (value) => {
		const regExpFiscalID = new RegExp(
			'^([VEJPG]{1})-([0-9]{8})-([0-9]{1}$)'
		);
		return regExpFiscalID.test(value);
	},
	message: 'El formato ingresado no es válido',
});
// custom email
extend('customEmail', {
	validate: (value) => {
		const reExpgCustomEmail = new RegExp(
			'^[a-zA-Z0-9._-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$'
		);
		return reExpgCustomEmail.test(value);
	},
	message: 'El formato ingresado no es válido',
});
//instagram
extend('validInstagram', {
	validate: (value) => {
		const regInstagramName = new RegExp('^[a-zA-Z0-9_.]{1,30}$');
		return regInstagramName.test(value);
	},
	message: 'El formato ingresado no es válido',
});
//twitter
extend('validTwitter', {
	validate: (value) => {
		const regTwitterName = new RegExp('^[a-zA-Z0-9_]{1,15}$');
		return regTwitterName.test(value);
	},
	message: 'El formato ingresado no es válido',
});
//youtube
extend('validYoutube', {
	validate: (value) => {
		//const regYoutubeChannel = /^(http(s)?:\/\/)?([w]{3}\.youtube\.com\/)([a-zA-Z0-9].{1,}$)/;
		const regYoutubeChannel = /^(http(s)?:\/\/)?([w]{3}\.youtube\.com\/)([a-zA-Z0-9_.=/#&+\-?]{1,}$)/;
		return regYoutubeChannel.test(value);
	},
	message: 'El formato ingresado no es válido',
});
//linkedin
extend('validLinkedin', {
	validate: (value) => {
		//const regLinkedinCompany = /^(http(s)?:\/\/)?([w]{3}\.linkedin\.com\/)([a-zA-Z0-9].{1,}$)/;
		const regLinkedinCompany = /^(http(s)?:\/\/)?([w]{3}\.linkedin\.com\/)([a-zA-Z0-9_.=/#&+\-?]{1,}$)/;
		return regLinkedinCompany.test(value);
	},
	message: 'El formato ingresado no es válido',
});
//facebook
extend('validFacebook', {
	validate: (value) => {
		//aqui
		//const regFacebookUser = /^(http(s)?:\/\/)?([w]{3}\.facebook\.com\/)([a-zA-Z0-9].{1,}$)/;
		const regFacebookUser = /^(http(s)?:\/\/)?([w]{3}\.facebook\.com\/)([a-zA-Z0-9_.=/#&+\-?]{1,}$)/;
		let isGroups = false;
		let validFacebook = regFacebookUser.test(value);
		if (validFacebook) {
			isGroups = value.includes('/groups/');
			if (value.includes('/groups/')) {
				return 'No se permite ingresar un perfil de grupos de Facebook';
			} else {
				return true;
			}
		}
		return false;
	},
	message: 'El formato ingresado no es válido',
});
//pagina web
extend('validWeb', {
	validate: (value) => {
		value = value.toLowerCase();
		const regUrlWeb = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
		const regHttp = /^(https?)/;
		let messageUrlNotAllowed = '';
		let haveHttp = regHttp.test(value);
		if (haveHttp) {
			if (regUrlWeb.test(value)) {
				urlNotAllowed.forEach((urlNotAllowed) => {
					for (let key in urlNotAllowed) {
						if (value.includes(urlNotAllowed.url)) {
							messageUrlNotAllowed = urlNotAllowed.message;
						}
					}
				});
				if (messageUrlNotAllowed !== '') {
					return messageUrlNotAllowed;
				}
				return true;
			} else{
				return false
			}
		} else {
			return 'Se debe incluir http:// o https:// al inicio de la URL';
		}
	},
	message: 'El formato ingresado no es válido',
});
//formato de los emails en un textarea
extend('validMultiEmails', {
	validate: (value) => {
		let emailList = value.split(',').map(function(item) {
			return item.trim();
		});
		let duplicatesEmails = emailList.filter(
			(item, index) => index !== emailList.indexOf(item)
		);
		//let regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		let regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
		for (let i = 0; i < emailList.length; i++) {
			let validEmail = regex.test(emailList[i]);
			if (!validEmail) {
				return (
					'El E-Mail ' +
					emailList[i] +
					' no posee el formato correcto.'
				);
			}
		}
		if (duplicatesEmails.length > 0) {
			return (
				'El E-Mail ' +
				duplicatesEmails[0] +
				' ya se encuentra en los E-Mails adicionales.'
			);
		}
		return true;
	},
	message: 'El formato ingresado no es válido',
});
//cantidad permitida de emails en un textarea
extend('cantEmailsTextArea', {
	validate: (value) => {
		let emailList = value.split(',').map(function(item) {
			return item.trim();
		});
		if (emailList.length > 5) {
			return false;
		}
		return true;
	},
	message: 'Solo puede ingresar hasta 5 E-Mails',
});
extend('validNumbersDedicated', {
	params: ['areaCodeNotPermited'],
	validate: (value) => {
		let trimValue = value.trim();
		let startWithAsterisc = trimValue.charAt(0) == '*' ? true : false; //empieza con asterisco
		let startWithParenthesis = trimValue.charAt(0) == '(' ? true : false; //es probable que sea un celular o numero local
		let startWithZero = trimValue.charAt(0) == '0' ? true : false; //es probable que sea un numero no geografico (0800,0500,0501)
		if (trimValue.length < 2) {
			return false;
		}
		if (startWithAsterisc) {
			return /^(?!(?:.*\*){2})[A-Za-z\d*]+$/.test(trimValue);
		}
		if (startWithParenthesis) {
			// let areaCode = trimValue.substring(1, 5);
			let validMobile = /^((\(04+(12|14|16|24|26)\))([0-9]{3})\.([0-9]{4}$))/.test(
				trimValue
			);
			if (validMobile) {
				return true;
			}
			if (!validMobile && trimValue.length == 14) {
				let validLocalPhone = /^(\(02+([0-9]{2})\))([0-9]{3})\.([0-9]{4}$)/.test(
					trimValue
				);
				return validLocalPhone;
			}
		}
		if (startWithZero) {
			let validDedicatedNumber = /^(0+(800|500|501|400))-(?!-)+(([0-9A-Za-z]|-(?!-)){7,10})$/.test(
				trimValue
			);
			return validDedicatedNumber;
		}
		return /^([1-9]{3})\.([0-9]{4}$)/.test(trimValue);
	},
	message: 'El formato ingresado no es válido',
});
//formato de los whatsapp en un textarea
extend('validMultiWhatsApp', {
	validate: (value) => {
		let whatsAppList = value.split(',').map(function(item) {
			return item.trim();
		});
		//let regex = /(\(0+([0-9]{3})\))([0-9]{3})\.([0-9]{4}$)/;
		//let internationalRegex = /(?!.*?\+58)(^\+?[\d]{2,3}[ ][\d]+$)/;
		let internationalRegex = /(?!.*?\+58)(^\+{1}[\d]{5,}$)/;
		let localPhoneRegex = /^(\(02+([0-9]{2})\))([0-9]{3})\.([0-9]{4}$)/;
		let mobilePhoneRegex = /^((\(04+(12|14|16|24|26)\))([0-9]{3})\.([0-9]{4}$))/;
		let errorMessage = '';
		let promises = [];
		for (let i = 0; i < whatsAppList.length; i++) {
			//si el numero empieza con el simbolo + es posible que sea internacional
			let isInternational =
				whatsAppList[i].charAt(0) == '+' ? true : false;
			//si empieza con ( es posible que sea local o celular
			let startWithParenthesis =
				whatsAppList[i].charAt(0) == '(' ? true : false;
			errorMessage =
				'El número ' + whatsAppList[i] + ' tiene un formato incorrecto';
			//si dejan una coma al final del numero sin nada a continuacion
			//se crea un espacio en blanco en el array de los numeros si eso ocurrre se regresa error
			if (whatsAppList[i] === '') {
				return 'Formato inválido';
			}
			//si es internacional valido que cumpla el formato
			if (isInternational) {
				if (!internationalRegex.test(whatsAppList[i])) {
					return errorMessage;
				}
			} else if (startWithParenthesis) {
				let areaCode = whatsAppList[i].substring(1, 5);
				//si el codigo de area empieza con 04 significa que posiblemente es un celular
				let isMobile = /^04/.test(areaCode);
				if (isMobile) {
					if (!mobilePhoneRegex.test(whatsAppList[i])) {
						return errorMessage;
					}
				} else {
					//si no es celular entonces se valida que cumple el formato de local
					//y si lo hace se valida que el codigo de area exista
					if (localPhoneRegex.test(whatsAppList[i])) {
						promises.push(
							axiosMailUpdate.get(
								'/api/v1/cities/verifyareacode/' +
									whatsAppList[i].substring(1, 5)
							)
						);
					} else {
						return errorMessage;
					}
				}
			} else if (!isInternational && !startWithParenthesis) {
				return errorMessage;
			}
		}
		return Promise.all(promises).then(
			(responses) => {
				return true;
			},
			(err) => {
				return err.response.data.error;
			}
		);
		//return true;
	},
	message: 'El formato ingresado no es válido',
});
//cantidad permitida de WhatsApp en un textarea
extend('cantWhatsAppTextArea', {
	validate: (value) => {
		let whatsAppList = value.split(',').map(function(item) {
			return item.trim();
		});
		if (whatsAppList.length > 3) {
			return false;
		}
		return true;
	},
	message: 'Solo puede ingresar hasta 3 números de WhatsApp',
});
//validador de telefonos, celulares y/o locales
extend('validPhone', {
	validate: (value) => {
		const regPhone = new RegExp(
			/^(\(0+([0-9]{3})\))([0-9]{3})\.([0-9]{4}$)/
		);
		let promises = [];
		let valid = false;
		let areaCode = value.substring(1, 5);
		let isMobile = /^04+(12|14|16|24|26)$/.test(areaCode);
		if (regPhone.test(value)) {
			if (!isMobile) {
				promises.push(
					axiosMailUpdate.get(
						'/api/v1/cities/verifyareacode/' + areaCode
					)
				);
				return Promise.all(promises).then(
					(responses) => {
						return true;
					},
					(err) => {
						return err.response.data.error;
					}
				);
			} else {
				valid = true;
			}
		}
		return valid;
		//return regPhone.test(value);
	},
	message: 'El formato ingresado no es válido',
});
//formato para los telefonos en el textarea, con o sin extensiones
extend('validMultiPhones', {
	validate: (value) => {
		/*expresion regular que combina 3 formatos validos de telefono, local (phoneWithParenthesis),
		local sin parentesis (phoneWithOutParenthesis) y celular (mobilePhoneRegex)*/
		let generalPhone = new RegExp( phoneWithParenthesis.source + "|" + phoneWithOutParenthesis.source + "|" + mobilePhoneRegex.source );
		let onlyLocalPhone = new RegExp( phoneWithParenthesis.source + "|" + phoneWithOutParenthesis.source);
		//se divide el string separado por comas y se convierte en un array
		// let phonesList = value.split(',').map(function(item) {
		// 	return item.trim();
		// });
		let phonesList = value.split(/[,\s]/).map(function(item) {
			return item.trim();
		});
		phonesList = phonesList.filter(n => n);
		//se crea un nuevo array con los telefonos que no tienen slash y que no tienen extensiones
		let withOutSlash = phonesList.filter((el) =>
		!el.includes("Ext") && !el.includes("/"));
		//se crea un nuevo array con los telefonos que tienen slash y que no tienen extensiones
		let withSlashes = phonesList.filter((el) => el.includes("/") && !el.includes("Ext"));
		let withExtension = phonesList.filter((el) => el.includes("Ext"));
		//si existen numeros con slash se aplican las validaciones de la siguiente seccion
		if (withSlashes.length > 0) {
			//se crea un array separando todos los numeros seguidos de un slash
			let slashesList = withSlashes.map(t => t.split('/'))
			for (let i = 0; i < slashesList.length; i++) {
				//se crea un array con los numeros para ser recorridos y validados
				let numbersToValidate = slashesList[i];
				for (let j = 0; j < numbersToValidate.length; j++) {
					/* si la posicion no posee un punto es posible que sea un numero luego de un slash por lo que se valida
					el formato del mismo con la expresion regular numbersAfterSlash */
					if (!numbersToValidate[j].includes('.')){
						//si la longitud es diferente de 4 se muestra error
						if (!numbersAfterSlash.test(numbersToValidate[j])) {
							let extraMessageForError = numbersToValidate[j]==''?'Se encontró un slash (/) en una posición incorrecta)':'Ingreso /' + numbersToValidate[j];
							return 'Después del simbolo / debe existir siempre 4 números. ' + extraMessageForError;
						}
					}else{
						/*si se trata de un numero con punto es posible que sea un numero local o celular por lo que se
						porcede a validar el formato del mismo usando la expresion regular generalPhone */
						if (!generalPhone.test(numbersToValidate[j])) {
							return 'El número ' + numbersToValidate[j] + ' no es válido';
						}
					}
				}
			}
		}
		//si existen numeros sin slashs ni extensiones se procede a validar el formato de cada numero en el array withOutSlash
		if (withOutSlash.length > 0) {
			for (let i = 0; i < withOutSlash.length; i++) {
				if (!generalPhone.test(withOutSlash[i])) {
					return 'El número ' + withOutSlash[i] + ' no es válido'
				}
			}
		}
		if (withExtension.length > 0) {
			//se crea un array separando todos los numeros seguidos de un slash
			let extensionList = withExtension.map(t => t.split(' '))
			for (let i = 0; i < extensionList.length; i++) {
				//se crea un array con los numeros para ser recorridos y validados
				let numbersToValidate = extensionList[i];
				for (let j = 0; j < numbersToValidate.length; j++) {
					if (numbersToValidate[j].charAt(0)==='E') {
						if (!formatExtension.test(numbersToValidate[j])) {
							return 'El número ' + numbersToValidate[j] + ' no es válido';
						}
					}else{
						if (mobilePhoneRegex.test(numbersToValidate[j])) {
							return 'El número celular ' + numbersToValidate[j] + ' no es permitido con el formato para extensiones';
						}
						if (!onlyLocalPhone.test(numbersToValidate[j])) {
							return 'El número ' + numbersToValidate[j] + ' no es válido';
						}
					}
				}
			}
		}
		return true;
	},
	message: 'El formato ingresado no es válido',
});
//para validar que el email adicional sea diferente al email principal
extend('distinctEmail', {
	params: ['target'],
	validate(value, { target }) {
		if (target !== '') {
			if (value === target) {
				return 'El E-Mail ' + target + ' ya existe como E-Mail principal.';
			}
		}else{
			return 'Se debe ingresar un E-Mail principal'
		}
		return true;
	},
	message: 'El E-Mail adicional debe ser diferente al principal',
});
//para validar que el numero dedicado ingresado sea diferente al numero telefonico en caso de ser solo uno
extend('distinctPhone', {
	params: ['target'],
	validate(value, { target }) {
		if (target !== '') {
			let phonesList = target.split(',').map(function(item) {
				return item.trim();
			});
			if (phonesList.length == 1) {
				return value === target ? false : true;
			}
		}
		return true;
	},
	message:
		'Si tiene solo un número telefónico no puede ingresar el mismo como número dedicado.',
});
//para validar que no se ingrese el codigo de area de la ciudad de la empresa
extend('validateCityAreaCode', {
	params: ['areaCodeNotAllowed'],
	validate(value, { areaCodeNotAllowed }) {
		let trimValue = value.trim();
		var regex = new RegExp(
			'^(\\(' + areaCodeNotAllowed + '\\))([0-9]{3})\\.([0-9]{4}$)'
		);
		let existAreaCodeNotAllowed = regex.test(trimValue);
		if (existAreaCodeNotAllowed) {
			return (
				'No es necesario ingresar el código de área ' +
				areaCodeNotAllowed +
				'. Puede colocar el número ' +
				trimValue.replace('(' + areaCodeNotAllowed + ')', '')
			);
		}
		return true;
	},
	message: 'No es necesario ingresar el código de área de su ciudad',
});
//validacion para indicar que no se debe ingresar direccion al ser empresa 100% virtual
extend('customRuleAddress', {
	params: ['companyType'],
	validate(value, { companyType }) {
		let companyTypeVirtual = 'V';
		let valid = ['', null, undefined].indexOf(value) === -1;
		if (valid && companyType === companyTypeVirtual) {
			return 'Su tipo de atención al público es de forma virtual por lo cual no se permite ingresar una dirección';
		}
		return true;
	},
	message: 'No se permite ingresar una dirección',
});
extend('referencePointNotAllowed', {
	params: ['companyType'],
	validate(value, { companyType }) {
		let companyTypeVirtual = 'V';
		let valid = ['', null, undefined].indexOf(value) === -1;
		if (valid && companyType === companyTypeVirtual) {
			return 'Su tipo de atención al público es de forma virtual por lo cual no se permite ingresar un punto de referencia';
		}
		return true;
	},
	message: 'No se permite ingresar una dirección',
});
extend('existAreaCode', {
	params: ['inputType'],
	validate(value, { inputType }) {
		let charForLocalNumber = '(02';
		let areaCode = 0;
		let promises = [];
		if (inputType === 'textarea') {
			// let phonesList = value.split(',').map(function(item) {
			// 	return item.trim();
			// });
			let phonesList = value.split(/[,\s]/).map(function(item) {
				return item.trim();
			});
			let onlyLocalNumbers = phonesList.filter((el) => el.includes(charForLocalNumber));
			if (onlyLocalNumbers.length > 0) {
				for (let index = 0; index < onlyLocalNumbers.length; index++) {
					areaCode = onlyLocalNumbers[index].substring(1, 5);
					promises.push(
						axiosMailUpdate.get(
							'/api/v1/cities/verifyareacode/' +
							areaCode
						)
					);
				}
			}
		}
		return Promise.all(promises).then(
			(responses) => {
				return true;
			},
			(err) => {
				return err.response.data.error;
			}
		);
	},
	message: 'No se permite ingresar una dirección',
});

extend('specialChar', {
	validate: (value) => {
		const regInstagramName = new RegExp('[0-9a-zA-Z_.\-/:]*');
		return regInstagramName.test(value);
	},
	message: 'El formato ingresado no es válido',
});
